<form name="frmLogin" >
    <div class="container panel panel-default col-md-offset-1 col-md-10" 
        style="padding-left: 0%; padding-right: 0%; border-color: black; height: 70vw; background-color: #f4f8f6; ">
        <div class="panel panel-heading" style="background: linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold; margin-top: -2.6%; color: white; ">Login</div>
        <div class="panel-body">
            <!-- <div class="activity-box" data-loading><div class="loading-spiner"><img src="/img/loadingVer.gif" /></div></div> -->
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-4 formDivCaptions">
                        <label>Enterprise ID</label>
                    </div>
                    <div class="col-md-4">
                        <input type="text" class="form-control " name="EnterpriseID" id="EnterpriseID" [(ngModel)]="EnterpriseID" />
                    </div>
                </div>
                <br />
                <div class="row">
                    <div class="col-md-2 col-md-offset-5">
                        <button id="btnLogin" type="button" class="btn btn-default btn-group-sm Button1" (click)="ChangeEntId()">
                            <span class="fa fa-arrow-circle-right" aria-hidden="true">
                            </span> Login
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <br />
    </div>
</form>